function DayModel(BaseModel, DayService) {
    'ngInject';

    class Day extends BaseModel {

        constructor(data) {
            super(...arguments);
            this.string_date = this.date;
            this.date = moment(this.date);
        }

        /***
         * @ngdoc method
         * @name day
         * @methodOf BB:Day
         * @description
         * Get day date
         *
         * @returns {date} The returned day
         */
        day() {
            return this.date.date();
        }

        /***
         * @ngdoc method
         * @name off
         * @methodOf BB:Day
         * @description
         * Get off by month
         *
         * @returns {date} The returned off
         */
        off(month) {
            return this.date.month() !== month;
        }

        /***
         * @ngdoc method
         * @name class
         * @methodOf BB:Day
         * @description
         * Get class in according of month
         *
         * @returns {string} The returned class
         */
        class(month) {
            let str = '';
            if (this.date.month() < month) {
                str += 'off off-prev';
            }
            if (this.date.month() > month) {
                str += 'off off-next';
            }
            if (this.spaces === 0) {
                str += ' not-avail';
            }
            return str;
        }

        static $query(prms) {
            return DayService.query(prms);
        }
    }

    return Day;
}

/***
 * @ngdoc service
 * @name BB:Day
 *
 * @description
 * Representation of an Day Object
 *
 * @property {string} string_date The string date
 * @property {date} date Second The date
 *///

angular
    .module('BB')
    .service('DayModel', DayModel);



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_models/day_model.service.js